function extractSearchTokens(search: string): string[] {
    const tokens: string[] = ['"', "'", ':', "=", ' '];
    const search_tokens: string[] = [];

    let buffer: string = ""
    for (let pos: number = 0; pos < search.length; pos++) {
        let char: string = search.charAt(pos);
        if (tokens.includes(char)) {
            if (buffer) {
                search_tokens.push(buffer);
            }

            search_tokens.push(char);
            buffer = "";
        } else {
            buffer += char;
        }
    }

    if (buffer) {
        search_tokens.push(buffer);
    }

    return search_tokens;
}

enum TokenType {
    KeyValue,
    Literal
}

interface Token {
    type: TokenType;
    value: string;
}

function createFilterTokens(words: string[]) {
    let state: string = "";
    let keyword: boolean = false;
    let quotes: boolean = false;

    let stack: string[][] = [[],];
    let tokens: Token[] = [];

    for (let pos: number = 0; pos < words.length; pos++) {
        let word = words[pos];

        if (keyword) {
            if (['"', "'"].includes(word) && !quotes) {
                stack.push([]);
                quotes = true;
            } else if (quotes) {
                if (['"', "'"].includes(word)) {
                    let phrase = stack.pop()!.join(' ');
                    let key = stack.pop()!;
                    
                    for (const word of key.slice(0, -1)) {
                        tokens.push({
                            type: TokenType.Literal,
                            value: word
                        })
                    }
    
                    keyword = false;
                    tokens.push({
                        type: TokenType.KeyValue,
                        value: key.at(-1) + ":" + phrase
                    })

                    keyword = false;
                    quotes = false;
                    stack.push([])
                } else {
                    if (word != " ") {
                        stack[stack.length - 1].push(word)
                    }
                }
                
            } else if (!quotes) {
                const words = stack.pop()!;
          
                for (const word of words.slice(0, -1)) {
                    tokens.push({
                        type: TokenType.Literal,
                        value: word
                    })
                }
                
                let key = words.at(-1);

                tokens.push({
                    type: TokenType.KeyValue,
                    value: key + ":" + word
                })

                keyword = false;
                stack.push([],)
            }
            
            state = ""
        } else if (quotes) {
            if (['"', "'"].includes(word)) {
                const phrase = stack.pop()!.join(' ')
                
                tokens.push({
                    type: TokenType.Literal,
                    value: phrase
                })

                quotes = false;
                stack.push([])
            } else {
                if (word != " ") {
                    stack[stack.length - 1].push(word);
                }
            }
        } else {
            if (['"', "'"].includes(word)) {
                // User wants to start a multi-space search
                // Push the current saved words to the tokens
                // Then start recording the incoming state
                const words = stack.pop()!;
          
                for (const word of words) {
                    tokens.push({
                        type: TokenType.Literal,
                        value: word
                    })
                }

                stack.push([])
                quotes = true;
            } else if ([":", "="].includes(word)) {
                // User wants to filter by field, set keyword flag to true
                // to start reading the value required in the field
                keyword = true;
            } else if (word != " ") {
                // There is no previous input and there is a word, save it
                // in the stack and continue to see what comes after
                stack[stack.length - 1].push(word)
            }
            
        }
    }

    if (stack.length > 0) {
        let words = stack.pop();
        if (words) {
            for (const word of words) {
                tokens.push({
                    type: TokenType.Literal,
                    value: word
                })
            }
        }
    }

    return tokens;
}

function applyFilter(elements, filter: string) {
    let search_tokens = extractSearchTokens(filter);
    let tokens = createFilterTokens(search_tokens);

    return elements.filter(element => {
        return tokens.some(token => {
            if (token.type == TokenType.Literal) {
                return Object.entries(element).some(el => {
                    let [pos, value] = el;
                    if (typeof (value) == 'string') {
                        if (value.toLocaleLowerCase().includes(token.value.toLocaleLowerCase())) {
                            return true;
                        }
                    }
                    return false;
                })
            } else if (token.type == TokenType.KeyValue) {
                let [key, value] = token.value.split(':')
                let _value = element[key]
                if (typeof _value == "boolean") {
                    return _value == (value.toLocaleLowerCase() == 'true')
                } else if (typeof _value == "string") {
                    return _value.toLocaleLowerCase()?.includes(value.toLocaleLowerCase());
                } else if (typeof _value == "number") {
                    return _value === Number(value);
                }
                return false;
            } else {
                throw "Error parsing search filter"
            }
        });
    });
}

export { applyFilter }
